import { isEqual } from "date-fns";
import { isBefore, parse } from "date-fns";

const States = [
    { value: "-1", display: '' },
    { value: 'AL', display: 'AL - Alabama' },
    { value: 'AK', display: 'AK - Alaska' },
    { value: 'AZ', display: 'AZ - Arizona' },
    { value: 'AR', display: 'AR - Arkansas' },
    { value: 'CA', display: 'CA - California' },
    { value: 'CO', display: 'C0 - Colorado' },
    { value: 'CT', display: 'CT - Connecticut' },
    { value: 'DE', display: 'DE - Delaware' },
    { value: 'FL', display: 'FL - Florida' },
    { value: 'GA', display: 'GA - Georgia' },
    { value: 'HI', display: 'HI - Hawaii' },
    { value: 'ID', display: 'ID - Idaho' },
    { value: 'IL', display: 'IL - Illinois' },
    { value: 'IN', display: 'IN - Indiana' },
    { value: 'IA', display: 'IA - Iowa' },
    { value: 'KS', display: 'KS - Kansas' },
    { value: 'KY', display: 'KY - Kentucky' },
    { value: 'LA', display: 'LA - Louisiana' },
    { value: 'ME', display: 'ME - Maine' },
    { value: 'MD', display: 'MD - Maryland' },
    { value: 'MA', display: 'MA - Massachusetts' },
    { value: 'MI', display: 'MI - Michigan' },
    { value: 'MN', display: 'MN - Minnesota' },
    { value: 'MS', display: 'MS - Mississippi' },
    { value: 'MO', display: 'MO - Missouri' },
    { value: 'MT', display: 'MT - Montana' },
    { value: 'NE', display: 'NE - Nebraska' },
    { value: 'NV', display: 'NV - Nevada' },
    { value: 'NH', display: 'NH - New Hampshire' },
    { value: 'NJ', display: 'NJ - New Jersey' },
    { value: 'NM', display: 'NM - New Mexico' },
    { value: 'NY', display: 'NY - New York' },
    { value: 'NC', display: 'NC - North Carolina' },
    { value: 'ND', display: 'ND - North Dakota' },
    { value: 'OH', display: 'OH - Ohio' },
    { value: 'OK', display: 'OK - Oklahoma' },
    { value: 'OR', display: 'OR - Oregon' },
    { value: 'PA', display: 'PA - Pennsylvania' },
    { value: 'RI', display: 'RI - Rhode Island' },
    { value: 'SC', display: 'SC - South Carolina' },
    { value: 'SD', display: 'SD - South Dakota' },
    { value: 'TN', display: 'TN - Tennessee' },
    { value: 'TX', display: 'TX - Texas' },
    { value: 'UT', display: 'UT - Utah' },
    { value: 'VT', display: 'VT - Vermont' },
    { value: 'VA', display: 'VA - Virginia' },
    { value: 'WA', display: 'WA - Washington' },
    { value: 'WV', display: 'WV - West Virginia' },
    { value: 'WI', display: 'WI - Wisconsin' },
    { value: 'WY', display: 'WY - Wyoming' },
    { value: 'DC', display: 'DC - District of Columbia' },
    { value: 'AS', display: 'AS - American Samoa' },
    { value: 'GU', display: 'GU - Guam' },
    { value: 'MP', display: 'MP - Northern Mariana Islands' },
    { value: 'PR', display: 'PR - Puerto Rico' },
    { value: 'UM', display: 'UM - United States Minor Outlying Islands' },
    { value: 'VI', display: 'VI - Virgin Islands, U.S.' },
]
export const AppointmentTypes = [
    { value: '', display: 'All' },
    { value: 'false', display: 'Individual' },
    { value: 'true', display: 'Group' },
]
export const TimeSlots = [
    { value: '15 Minutes', display: '15 Minutes' },
    { value: '30 Minutes', display: '30 Minutes' },
    { value: '45 Minutes', display: '45 Minutes' },
    { value: '60 Minutes', display: '60 Minutes' },
]
export const AdmissionStatusDropDown = [
    { value: '', display: '' },
    { value: 'Active', display: 'Active' },
    { value: 'Hold', display: 'Hold' },
    { value: 'Discharged', display: 'Discharged' },
    { value: 'Vacation', display: 'Vacation' },
    { value: 'Hospitalization', display: 'Hospitalization' },
]
export const Credentials = [
    { value: '-1', display: '' },
    { value: 'MD', display: 'MD - Doctor of Medicine' },
    { value: 'DO', display: 'DO - Doctor of Osteopathic Medicine' },
    { value: 'MBBS or MBBCh', display: 'MBBS or MBBCh - Bachelor of Medicine and Bachelor of Surgery' },
    { value: 'NP', display: 'NP - Nurse Practitioner' },
    { value: 'APRN', display: 'APRN - Advanced Practice Registered Nurse' },
    { value: 'PA-C', display: 'PA-C - Physician Assistant-Certified' },
    { value: 'CRNA', display: 'CRNA - Certified Registered Nurse Anesthetist' },
    { value: 'CNM', display: 'CNM - Certified Nurse Midwife' },
    { value: 'CNS', display: 'CNS - Clinical Nurse Specialist' },
    { value: 'DPM', display: 'DPM - Doctor of Podiatric Medicine' },
    { value: 'DDS', display: 'DDS - Doctor of Dental Surgery' },
    { value: 'DMD', display: 'DMD - Doctor of Dental Medicine' },
    { value: 'OD', display: 'OD - Doctor of Optometry' },
    { value: 'DC', display: 'DC - Doctor of Chiropractic' },
    { value: 'ND', display: 'ND - Doctor of Naturopathic Medicine' },
    { value: 'DPT', display: 'DPT - Doctor of Physical Therapy' },
    { value: 'PsyD', display: 'PsyD - Doctor of Psychology' },
    { value: 'PhD', display: 'PhD - Doctor of Philosophy' },
    { value: 'LCSW-', display: 'LCSW - Licensed Clinical Social Worker' },
    { value: 'LICSW', display: 'LICSW - Licensed Independent Clinical Social Worker' },
    { value: 'LISW', display: 'LISW - Licensed Independent Social Worker' },
    { value: 'LMFT', display: 'LMFT - Licensed Marriage and Family Therapist' },
    { value: 'LCPC', display: 'LCPC - Licensed Clinical Professional Counselor' },
    { value: 'LPC', display: 'LPC - Licensed Professional Counselor' },
    { value: 'CSW', display: 'CSW - Clinical Social Worker' },
    { value: 'MSW', display: 'MSW - Master of Social Work' },
    { value: 'DSW', display: 'DSW - Doctor of Social Work' },
    { value: 'PharmD', display: 'PharmD - Doctor of Pharmacy' },
    { value: 'DSc', display: 'DSc - Doctor of Science' },
    { value: 'DrPH', display: 'DrPH - Doctor of Public Health' },
    { value: 'MPH', display: 'MPH - Master of Public Health' },
    { value: 'MHA', display: 'MHA - Master of Health Administration' },
    { value: 'RN', display: 'RN - Registered Nurse' },
    { value: 'LVN', display: 'LVN - Licensed Vocational Nurse' },
    { value: 'LPN', display: 'LPN - Licensed Practical Nurse' },
    { value: 'PT', display: 'PT - Physical Therapist' },
    { value: 'OT', display: 'OT - Occupational Therapist' },
    { value: 'SLP', display: 'SLP - Speech-Language Pathologist' },
    { value: 'RD', display: 'RD - Registered Dietitian' },
    { value: 'AUD', display: 'AUD - Doctor of Audiology' },
    { value: 'DPA', display: 'DPA - Doctor of Public Administration' },
    { value: 'LMBT', display: 'LMBT-Licensed Massage and Bodywork Therapist' },






    // { value: 'PhD', display: 'PhD' },
    // { value: 'DNP ', display: 'DNP ' },
    // { value: 'NP and PA', display: 'NP and PA' },
    // { value: 'CNP', display: 'CNP' },
    // { value: 'CNNP', display: 'CNNP' },
    // { value: 'PA', display: 'PA' },
    // { value: 'CNS', display: 'CNS' },
    // { value: 'CNM', display: 'CNM' },
    // { value: 'LCSW', display: 'LCSW' },
]
export const TOSCodes = [
    { value: '1', display: '1 - Medical Care' },
    { value: '2', display: '2 - Surgical Care' },
    { value: '3', display: '3 - Consultation' },
    { value: '4', display: '4 - Diagnostic X-Ray' },
    { value: '5', display: '5 - Diagnostic Lab' },
    { value: '6', display: '6 - Radiation Therapy' },
    { value: '7', display: '7 - Anesthesia' },
    { value: '8', display: '8 - Laboratory' },
    { value: '9', display: '9 - Other Medical' }
];
export const NDCUnitOfMeasurement = [
    { value: 'F2', display: 'F2 - International Unit' },
    { value: 'GR', display: 'GR - Gram' },
    { value: 'ME', display: 'ME - Milligram' },
    { value: 'ML', display: 'ML - Milliliter' },
    { value: 'UN', display: 'UN - Unit' },
]
export const MeasurementCodeDD = [
    { value: '', display: '' },
    { value: 'OG', display: 'OG - Original' },
    { value: 'TR', display: 'TR - Test Results' },

]
export const MeasurementTypeDD = [
    { value: '', display: '' },
    { value: 'HT', display: 'HT - Height ' },
    { value: 'R1', display: 'R1 - Hemoglobin ' },
    { value: 'R2', display: 'R2 - Hematocrit' },
    { value: 'R3', display: 'R3 - Epoetin Starting Dosage' },
    { value: 'R4', display: 'R4 - Creatinine' },


]
export const AuthorizationFrequency = [
    // { value: '-1', display: '' },
    // { value: 'Daily', display: 'Daily' },
    // { value: 'Weekly', display: 'Weekly' },
    // { value: 'Monthly', display: 'Monthly' },
    { value: 'Entire Period', display: 'Entire Period' },
]
export const AuthorizationFrequencyHomeCare = [
    // { value: '-1', display: '' },
    // { value: 'Daily', display: 'Daily' },
    { value: 'Weekly', display: 'Weekly' },
    // { value: 'Monthly', display: 'Monthly' },
    // { value: ' Entire Period', display: ' Entire Period' },
]
export const Alphbets = [
    { value: 'A' },
    { value: 'B' },
    { value: 'C' },
    { value: 'D' },
    { value: 'E' },
    { value: 'F' },
    { value: 'G' },
    { value: 'H' },
    { value: 'I' },
    { value: 'J' },
    { value: 'K' },
    { value: 'L' },
    { value: 'M' },
    { value: 'N' },
    { value: 'O' },
    { value: 'P' },
    { value: 'Q' },
    { value: 'R' },
    { value: 'S' },
    { value: 'T' },
    { value: 'U' },
    { value: 'V' },
    { value: 'W' },
    { value: 'X' },
    { value: 'Y' },
    { value: 'Z' },
]
export const Countries = [
    { value: '', display: '' },
    { value: 'Afghanistan', display: 'Afghanistan' },
    { value: 'Albania', display: 'Albania' },
    { value: 'Algeria', display: 'Algeria' },
    { value: 'Andorra', display: 'Andorra' },
    { value: 'Angola', display: 'Angola' },
    { value: 'Antigua and Barbuda', display: 'Antigua and Barbuda' },
    { value: 'Argentina', display: 'Argentina' },
    { value: 'Armenia', display: 'Armenia' },
    { value: 'Australia', display: 'Australia' },
    { value: 'Austria', display: 'Austria' },
    { value: 'Azerbaijan', display: 'Azerbaijan' },
    { value: 'Bahamas', display: 'Bahamas' },
    { value: 'Bahrain', display: 'Bahrain' },
    { value: 'Bangladesh', display: 'Bangladesh' },
    { value: 'Barbados', display: 'Barbados' },
    { value: 'Belarus', display: 'Belarus' },
    { value: 'Belgium', display: 'Belgium' },
    { value: 'Belize', display: 'Belize' },
    { value: 'Benin', display: 'Benin' },
    { value: 'Bhutan', display: 'Bhutan' },
    { value: 'Bolivia', display: 'Bolivia' },
    { value: 'Bosnia and Herzegovina', display: 'Bosnia and Herzegovina' },
    { value: 'Botswana', display: 'Botswana' },
    { value: 'Brazil', display: 'Brazil' },
    { value: 'Brunei', display: 'Brunei' },
    { value: 'Bulgaria', display: 'Bulgaria' },
    { value: 'Burkina Faso', display: 'Burkina Faso' },
    { value: 'Burundi', display: 'Burundi' },
    { value: 'Cabo Verde', display: 'Cabo Verde' },
    { value: 'Cambodia', display: 'Cambodia' },
    { value: 'Cameroon', display: 'Cameroon' },
    { value: 'Canada', display: 'Canada' },
    { value: 'Central African Republic', display: 'Central African Republic' },
    { value: 'Chad', display: 'Chad' },
    { value: 'Chile', display: 'Chile' },
    { value: 'China', display: 'China' },
    { value: 'Colombia', display: 'Colombia' },
    { value: 'Comoros', display: 'Comoros' },
    { value: 'Congo', display: 'Congo' },
    { value: 'Costa Rica', display: 'Costa Rica' },
    { value: 'Côte d’Ivoire', display: 'Côte d’Ivoire' },
    { value: 'Croatia', display: 'Croatia' },
    { value: 'Cuba', display: 'Cuba' },
    { value: 'Cyprus', display: 'Cyprus' },
    { value: 'Czechia', display: 'Czechia' },
    { value: 'Denmark', display: 'Denmark' },
    { value: 'Djibouti', display: 'Djibouti' },
    { value: 'Dominica', display: 'Dominica' },
    { value: 'Dominican Republic', display: 'Dominican Republic' },
    { value: 'Ecuador', display: 'Ecuador' },
    { value: 'Egypt', display: 'Egypt' },
    { value: 'El Salvador', display: 'El Salvador' },
    { value: 'Equatorial Guinea', display: 'Equatorial Guinea' },
    { value: 'Eritrea', display: 'Eritrea' },
    { value: 'Estonia', display: 'Estonia' },
    { value: 'Eswatini', display: 'Eswatini' },
    { value: 'Ethiopia', display: 'Ethiopia' },
    { value: 'Fiji', display: 'Fiji' },
    { value: 'Finland', display: 'Finland' },
    { value: 'France', display: 'France' },
    { value: 'Gabon', display: 'Gabon' },
    { value: 'Gambia', display: 'Gambia' },
    { value: 'Georgia', display: 'Georgia' },
    { value: 'Germany', display: 'Germany' },
    { value: 'Ghana', display: 'Ghana' },
    { value: 'Greece', display: 'Greece' },
    { value: 'Grenada', display: 'Grenada' },
    { value: 'Guatemala', display: 'Guatemala' },
    { value: 'Guinea', display: 'Guinea' },
    { value: 'Guinea-Bissau', display: 'Guinea-Bissau' },
    { value: 'Guyana', display: 'Guyana' },
    { value: 'Haiti', display: 'Haiti' },
    { value: 'Honduras', display: 'Honduras' },
    { value: 'Hungary', display: 'Hungary' },
    { value: 'Iceland', display: 'Iceland' },
    { value: 'India', display: 'India' },
    { value: 'Indonesia', display: 'Indonesia' },
    { value: 'Iran', display: 'Iran' },
    { value: 'Iraq', display: 'Iraq' },
    { value: 'Ireland', display: 'Ireland' },
    { value: 'Israel', display: 'Israel' },
    { value: 'Italy', display: 'Italy' },
    { value: 'Jamaica', display: 'Jamaica' },
    { value: 'Japan', display: 'Japan' },
    { value: 'Jordan', display: 'Jordan' },
    { value: 'Kazakhstan', display: 'Kazakhstan' },
    { value: 'Kenya', display: 'Kenya' },
    { value: 'Kiribati', display: 'Kiribati' },
    { value: 'Kuwait', display: 'Kuwait' },
    { value: 'Kyrgyzstan', display: 'Kyrgyzstan' },
    { value: 'Laos', display: 'Laos' },
    { value: 'Latvia', display: 'Latvia' },
    { value: 'Lebanon', display: 'Lebanon' },
    { value: 'Lesotho', display: 'Lesotho' },
    { value: 'Liberia', display: 'Liberia' },
    { value: 'Libya', display: 'Libya' },
    { value: 'Liechtenstein', display: 'Liechtenstein' },
    { value: 'Lithuania', display: 'Lithuania' },
    { value: 'Luxembourg', display: 'Luxembourg' },
    { value: 'Madagascar', display: 'Madagascar' },
    { value: 'Malawi', display: 'Malawi' },
    { value: 'Malaysia', display: 'Malaysia' },
    { value: 'Maldives', display: 'Maldives' },
    { value: 'Mali', display: 'Mali' },
    { value: 'Malta', display: 'Malta' },
    { value: 'Marshall Islands', display: 'Marshall Islands' },
    { value: 'Mauritania', display: 'Mauritania' },
    { value: 'Mauritius', display: 'Mauritius' },
    { value: 'Mexico', display: 'Mexico' },
    { value: 'Micronesia', display: 'Micronesia' },
    { value: 'Moldova', display: 'Moldova' },
    { value: 'Monaco', display: 'Monaco' },
    { value: 'Mongolia', display: 'Mongolia' },
    { value: 'Montenegro', display: 'Montenegro' },
    { value: 'Morocco', display: 'Morocco' },
    { value: 'Mozambique', display: 'Mozambique' },
    { value: 'Myanmar', display: 'Myanmar' },
    { value: 'Namibia', display: 'Namibia' },
    { value: 'Nauru', display: 'Nauru' },
    { value: 'Nepal', display: 'Nepal' },
    { value: 'Netherlands', display: 'Netherlands' },
    { value: 'New Zealand', display: 'New Zealand' },
    { value: 'Nicaragua', display: 'Nicaragua' },
    { value: 'Niger', display: 'Niger' },
    { value: 'Nigeria', display: 'Nigeria' },
    { value: 'North Korea', display: 'North Korea' },
    { value: 'North Macedonia', display: 'North Macedonia' },
    { value: 'Norway', display: 'Norway' },
    { value: 'Oman', display: 'Oman' },
    { value: 'Pakistan', display: 'Pakistan' },
    { value: 'Palau', display: 'Palau' },
    { value: 'Palestine', display: 'Palestine' },
    { value: 'Panama', display: 'Panama' },
    { value: 'Papua New Guinea', display: 'Papua New Guinea' },
    { value: 'Paraguay', display: 'Paraguay' },
    { value: 'Peru', display: 'Peru' },
    { value: 'Philippines', display: 'Philippines' },
    { value: 'Poland', display: 'Poland' },
    { value: 'Portugal', display: 'Portugal' },
    { value: 'Qatar', display: 'Qatar' },
    { value: 'Romania', display: 'Romania' },
    { value: 'Russia', display: 'Russia' },
    { value: 'Rwanda', display: 'Rwanda' },
    { value: 'Saint Kitts and Nevis', display: 'Saint Kitts and Nevis' },
    { value: 'Saint Lucia', display: 'Saint Lucia' },
    { value: 'Saint Vincent and the Grenadines', display: 'Saint Vincent and the Grenadines' },
    { value: 'Samoa', display: 'Samoa' },
    { value: 'San Marino', display: 'San Marino' },
    { value: 'Sao Tome and Principe', display: 'Sao Tome and Principe' },
    { value: 'Saudi Arabia', display: 'Saudi Arabia' },
    { value: 'Senegal', display: 'Senegal' },
    { value: 'Serbia', display: 'Serbia' },
    { value: 'Seychelles', display: 'Seychelles' },
    { value: 'Sierra Leone', display: 'Sierra Leone' },
    { value: 'Singapore', display: 'Singapore' },
    { value: 'Slovakia', display: 'Slovakia' },
    { value: 'Slovenia', display: 'Slovenia' },
    { value: 'Solomon Islands', display: 'Solomon Islands' },
    { value: 'Somalia', display: 'Somalia' },
    { value: 'South Africa', display: 'South Africa' },
    { value: 'South Korea', display: 'South Korea' },
    { value: 'South Sudan', display: 'South Sudan' },
    { value: 'Spain', display: 'Spain' },
    { value: 'Sri Lanka', display: 'Sri Lanka' },
    { value: 'Sudan', display: 'Sudan' },
    { value: 'Suriname', display: 'Suriname' },
    { value: 'Sweden', display: 'Sweden' },
    { value: 'Switzerland', display: 'Switzerland' },
    { value: 'Syria', display: 'Syria' },
    { value: 'Taiwan', display: 'Taiwan' },
    { value: 'Tajikistan', display: 'Tajikistan' },
    { value: 'Tanzania', display: 'Tanzania' },
    { value: 'Thailand', display: 'Thailand' },
    { value: 'Timor-Leste', display: 'Timor-Leste' },
    { value: 'Togo', display: 'Togo' },
    { value: 'Tonga', display: 'Tonga' },
    { value: 'Trinidad and Tobago', display: 'Trinidad and Tobago' },
    { value: 'Tunisia', display: 'Tunisia' },
    { value: 'Turkey', display: 'Turkey' },
    { value: 'Turkmenistan', display: 'Turkmenistan' },
    { value: 'Tuvalu', display: 'Tuvalu' },
    { value: 'Uganda', display: 'Uganda' },
    { value: 'Ukraine', display: 'Ukraine' },
    { value: 'United Arab Emirates', display: 'United Arab Emirates' },
    { value: 'United Kingdom', display: 'United Kingdom' },
    { value: 'United States', display: 'United States' },
    { value: 'Uruguay', display: 'Uruguay' },
    { value: 'Uzbekistan', display: 'Uzbekistan' },
    { value: 'Vanuatu', display: 'Vanuatu' },
    { value: 'Vatican City', display: 'Vatican City' },
    { value: 'Venezuela', display: 'Venezuela' },
    { value: 'Vietnam', display: 'Vietnam' },
    { value: 'Yemen', display: 'Yemen' },
    { value: 'Zambia', display: 'Zambia' },
    { value: 'Zimbabwe', display: 'Zimbabwe' }
]
export const BirthOrder = [
    { value: '-1', display: '' },
    { value: 'First Borns', display: 'First Borns' },
    { value: 'Last Borns', display: 'Last Borns' },
    { value: 'Middle Borns', display: 'Middle Borns' },
    { value: 'The Only Child', display: 'The Only Child' },
]
export const GenderIdentity = [
    { value: '-1', display: '' },
    { value: 'Male', display: 'Male' },
    { value: 'Female', display: 'Female' },
    { value: 'Transgender Male/Trans Man/Female-to-Male', display: 'Transgender Male/Trans Man/Female-to-Male' },
    { value: 'Transgender Female/Trans Woman/Male-to-Female', display: 'Transgender Female/Trans Woman/Male-to-Female' },
    { value: 'Genderqueer, neither exclusively Male nor Female', display: 'Genderqueer, neither exclusively Male nor Female' },
    { value: 'Additional gender category or other', display: 'Additional gender category or other' },
    { value: 'Unknown', display: 'Unknown' },
    { value: 'Patient declines to specify', display: 'Patient declines to specify' },

]
export const PreferredCareGiverGender = [
    { value: '-1', display: '' },
    { display: 'Male', value: 'M' },
    { display: 'Female', value: 'F' },
    { display: 'Other', value: 'O' },
]
export const RenderingProRule = [
    { value: '', display: '' },
    { value: 'Always Report', display: 'Always Report' },
    { value: 'Dont Report', display: 'Dont Report' },
    { value: 'Report When different from Billing', display: 'Report When different from Billing' },
]
export const LocationProRule = [
    { value: '', display: '' },
    { value: 'Always Report', display: 'Always Report' },
    { value: 'Dont Report', display: 'Dont Report' },
    { value: 'Report When different from Billing', display: 'Report When different from Billing' },
]
export const SexualOrientation = [
    { value: '-1', display: '' },
    { value: 'Heterosexual/Straight', display: 'Heterosexual/Straight' },
    { value: 'Homosexual/Gay/Lesbian', display: 'Homosexual/Gay/Lesbian' },
    { value: 'Bisexual', display: 'Bisexual' },
    { value: 'Other', display: 'Other' },
    { value: 'Unknown', display: 'Unknown' },
    { value: 'Patient declines to specify', display: 'Patient declines to specify' },

]
export const BloodGroup = [
    { value: '-1', display: '' },
    { value: 'A+', display: 'A+' },
    { value: 'A-', display: 'A-' },
    { value: 'B+', display: 'B+' },
    { value: 'B-', display: 'B-' },
    { value: 'O+', display: 'O+' },
    { value: 'O-', display: 'O-' },
    { value: 'AB+', display: 'AB+' },
    { value: 'AB-', display: 'AB-' },

]
export const EmploymentStatus = [
    { display: '', value: '-1' },
    { display: 'Employeed', value: '1' },
    { display: 'UnEmployeed', value: '2' },
    { display: 'Retired', value: '3' },
    { display: 'Patient declines to specify', value: '0' },
]
export const StudentStatus = [
    { value: '-1', display: '' },
    { value: '1', display: 'Employed' },
    { value: '0', display: 'Full-time Student' },
    { value: '2', display: 'Part-time Student' },
    { value: '3', display: 'Not a Student' },

]
export const Class = [
    { value: '' },
    { value: 'Employeed', display: 'Employeed' },
    { value: 'Unemployeed', display: 'Unemployeed' },
    { value: 'No Reponse', display: 'No Reponse' },
]
export const ExportFormat = [
    { value: '-1', display: '' },
    { value: '837P', display: '837P - Professional Claims' },
    { value: '837I', display: '837I - Institutional Claims' },
    { value: '837D', display: '837D - Dental Claims' },
    { value: '276', display: '276 - Claim Status' },
    { value: '270', display: '270 - Patient Eligibility' },
]
export const EDIVersion = [
    { value: '-1', display: '' },
    { value: '5010', display: '5010' },

]
export const ClaimType = [
    { value: '-1', display: '' },
    { value: '31', display: 'Subrogation Demand' },
    { value: 'CH', display: 'Chargeable' },
    { value: 'RP', display: 'Reporting ' },
]
export const ISA01 = [
    { value: '-1', display: '' },
    { value: '00', display: '00 ' },
    { value: '03', display: '03 ' },
]
export const ISA03 = [
    { value: '-1', display: '' },
    { value: '00', display: '00 ' },
    { value: '01', display: '01 ' },
]
export const ISA05 = [
    { value: '-1', display: '' },
    { value: '01', display: '01 ' },
    { value: '14', display: '14 ' },
    { value: '20', display: '20 ' },
    { value: '27', display: '27 ' },
    { value: '28', display: '28 ' },
    { value: '29', display: '29 ' },
    { value: '30', display: '30 ' },
    { value: '33', display: '33 ' },
    { value: 'ZZ', display: 'ZZ ' },
]
export const ISA07 = [
    { value: '-1', display: '' },
    { value: '01', display: '01 ' },
    { value: '14', display: '14 ' },
    { value: '20', display: '20 ' },
    { value: '27', display: '27 ' },
    { value: '28', display: '28 ' },
    { value: '29', display: '29 ' },
    { value: '30', display: '30 ' },
    { value: '33', display: '33 ' },
    { value: 'ZZ', display: 'ZZ ' },
]
export const ISA15 = [
    { value: '', display: '' },
    { value: 'P', display: 'Production ' },
    { value: 'T', display: 'Test ' },

]
export const Type = [
    { value: '-1', display: '' },
    { value: '1', display: 'Person' },
    { value: '2', display: 'Organization' },
]
export const ConnectivityType = [
    { value: '-1', display: '' },
    { value: 'SFTP', display: 'SFTP' },
    { value: 'FTP', display: 'FTP' },
    { value: 'API', display: 'API' },
]
export const Status = [
    { value: null, display: '' },
    { value: true, display: 'Active' },
    { value: false, display: 'InActive' }
]
export const Gender = [
    { value: '-1', display: '' },
    { display: 'Male', value: 'M' },
    { display: 'Female', value: 'F' },
    { display: 'Other', value: 'O' },
];
export const GenderDemographic = [
    { value: '-1', display: '' },
    { display: 'Male', value: 'M' },
    { display: 'Female', value: 'F' },
    { display: 'Other', value: 'O' },
    { display: 'Unknown', value: 'Unknown' },
    { display: 'Patient declines to specify', value: 'Patient declines to specify' },

];
export const MaritalStatus = [
    { value: '-1', display: '' },
    { display: 'Single', value: 'S' },
    { display: 'Married', value: 'M' },
    { display: 'Separated', value: 'SP' },
    { display: 'Divorced', value: 'D' },
    { display: 'Widowed', value: 'W' },
    { display: 'Other', value: 'O' },
]
export const Languages = [
    { value: 'Acehnese' },
    { value: 'Acholi' },
    { value: 'Afar' },
    { value: 'Afrikaans' },
    { value: 'Akan' },
    { value: 'Albanian' },
    { value: 'Amharic' },
    { value: 'Anlo' },
    { value: 'Arabic' },
    { value: 'Armenian' },
    { value: 'Askunu' },
    { value: 'Assamese' },
    { value: 'Azerbaijani' },
    { value: 'Badini' },
    { value: 'Balinese' },
    { value: 'Balochi' },
    { value: 'Bangla' },
    { value: 'Banyuwangi' },
    { value: 'Batak' },
    { value: 'Beja' },
    { value: 'Belarusian' },
    { value: 'Bemba' },
    { value: 'Bengali' },
    { value: 'Berber (Tamazight)' },
    { value: 'Bete' },
    { value: 'Bhili' },
    { value: 'Bhojpuri' },
    { value: 'Bikol' },
    { value: 'Bilen' },
    { value: 'Bosnian' },
    { value: 'Brahui' },
    { value: 'Bravanese' },
    { value: 'Buginese' },
    { value: 'Bulgarian' },
    { value: 'Burmese' },
    { value: 'Cantonese' },
    { value: 'Catalan' },
    { value: 'Cebuano' },
    { value: 'Chichewa (Nyanja)' },
    { value: 'Chinese' },
    { value: 'Croatian' },
    { value: 'Comorian' },
    { value: 'Czech' },
    { value: 'Danish' },
    { value: 'Dari' },
    { value: 'Dioula' },
    { value: 'Dyula' },
    { value: 'Dutch' },
    { value: 'Edo' },
    { value: 'English' },
    { value: 'Eritrean' },
    { value: 'Estonian' },
    { value: 'Ewe' },
    { value: 'Farsi' },
    { value: 'Fataluku' },
    { value: 'Fijian' },
    { value: 'Filipino (Tagalog)' },
    { value: 'Finnish' },
    { value: 'Flemish' },
    { value: 'French' },
    { value: 'Fujianese' },
    { value: 'Fulani' },
    { value: 'Fur' },
    { value: 'Ga' },
    { value: 'Gaelic' },
    { value: 'Galician' },
    { value: 'Gan' },
    { value: 'Georgian' },
    { value: 'German' },
    { value: 'Ghanaian' },
    { value: 'Gibanawa' },
    { value: 'Gikuyu' },
    { value: 'Gilaki' },
    { value: 'Greek' },
    { value: 'Guarani' },
    { value: 'Gujarati' },
    { value: 'Gullah' },
    { value: 'Haitian Creole' },
    { value: 'Hakka' },
    { value: 'Hausa' },
    { value: 'Hazaragi' },
    { value: 'Herero' },
    { value: 'Hiligaynon' },
    { value: 'Hindi' },
    { value: 'Hindko' },
    { value: 'Hindustani' },
    { value: 'Hmar' },
    { value: 'Hmong' },
    { value: 'Hokkien' },
    { value: 'Hungarian' },
    { value: 'Hwla' },
    { value: 'Icelandic' },
    { value: 'Igbo (Ibo)' },
    { value: 'Ilokano' },
    { value: 'Ilonggo' },
    { value: 'Imeraguen' },
    { value: 'Indian' },
    { value: 'Indonesian' },
    { value: 'Inuktitut' },
    { value: 'Ishkashimi' },
    { value: 'Italian' },
    { value: 'Iu Mien' },
    { value: 'Jamaican Creole' },
    { value: 'Javanese' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },
    { value: 'Hmong' },

]
export const AccidentType = [
    { value: null, display: '' },
    { value: 'AA', display: 'AA-Auto Accident' },
    { value: 'EM', display: 'EM-Employment' },
    { value: 'OA', display: 'OA-Other Accident' },
];
export const ServiceAuthExcCode = [
    { value: null, display: '' },
    { value: '1', display: '1-Immediate/Urgent Care' },
    { value: '2', display: '2-Services Rendered in a Retroactive Period' },
    { value: '3', display: '3-Emergency Care' },
    { value: '4', display: '4-Client has Temporary Medicaid' },
    { value: '5', display: '5-Request from County for Second Opinion to Determine if Recipient Can Work' },
    { value: '6', display: '6-Request for Override Pending' },
    { value: '7', display: '7-Special Handling' },
];
export const DelayReasonCode = [
    { value: null, display: '' },
    { value: '1', display: '1-Proof of Eligibility Unknown or Unavailable' },
    { value: '2', display: '2-Litigation' },
    { value: '3', display: '3-Authorization Delays' },
    { value: '4', display: '4-Delay in Certifying Provider' },
    { value: '5', display: '5-Delay in Supplying Billing Forms' },
    { value: '6', display: '6-Delay in Delivery of Custom-made Appliances' },
    { value: '7', display: '7-Third Party Processing Delay' },
    { value: '8', display: '8-Delay in Eligibility Determination' },
    { value: '9', display: '9-Original Claim Rejected or Denied Due to a Reason Unrelated to the Billing Limitation Rules' },
    { value: '10', display: '10-Administration Delay in the Prior Approval Process' },
    { value: '11', display: '11-Natural Disaster' },
    { value: '15', display: '15-Other' },

];
export const UserType = [
    { value: '', display: '' },
    { value: 'Billing User', display: 'Billing User' },
    { value: 'EHR User', display: 'EHR User' },
    { value: 'Both', display: 'Both' },
]
export const SpecialProgramCode = [
    { value: null, display: '' },
    { value: '02', display: '02-Physically Handicapped Childrens Program' },
    { value: '03', display: '03-Special Federal Funding' },
    { value: '05', display: '05-Disability' },
    { value: '09', display: '09-Second Opinion or Surgery' },
];
export const ClaimFrequencyCode = [
    { value: null, display: '' },
    { value: '0', display: 'Non-payment/zero claims' },
    { value: '1', display: 'Admit thru discharge claim' },
    { value: '2', display: 'Interim — first claim' },
    { value: '3', display: 'Interim — continuing claim' },
    { value: '4', display: 'Interim — last claim' },
    { value: '5', display: 'Late charge(s) only claim' },
    { value: '7', display: 'Replacement of prior claim' },
    { value: '8', display: 'Void/cancel prior claim' },
    { value: '9', display: 'Final claim (for HH PPS = process as a debit/credit to RAP claim)' },
    { value: 'G', display: 'Common Working File (NCH) generated adjustment claim' },
    { value: 'H', display: 'CMS generated adjustment claim' },
    { value: 'I', display: 'Misc adjustment claim (e.g., initiated by intermediary or QIO)' },
    { value: 'J', display: 'Other adjustment request' },
    { value: 'K', display: 'OIG Initiated Adjustment Claim' },
    { value: 'M', display: 'Medicare secondary payer (MSP) adjustment' },
    { value: 'P', display: 'Adjustment required by QIO' },
    { value: 'Q', display: 'Reopening/Adjustment requested by provider' },

];
export const Relation = [
    { value: '' },
    { value: 'Emplyoee', display: 'Emplyoee' },
    { value: 'Self', display: 'Self' },
    { value: 'Spouse', display: 'Spouse' },
    { value: 'Child', display: 'Child' },
    { value: 'Other', display: 'Other' },
    { value: 'Father', display: 'Father' },
    { value: 'Mother', display: 'Mother' },
    { value: 'Sibling', display: 'Sibling' },
];
export const Relationship = [
    { display: '', value: '' },
    { display: '01 - Spouse', value: '01' },
    { display: '18 - Self', value: '18' },
    { display: '19 - Child', value: '19' },
    { display: '20 - Employee', value: '20' },
    { display: '21 - Unknown', value: '21' },
    { display: '39 - Organ Donor', value: '39' },
    { display: '40 - Cadaver Donor', value: '40' },
    { display: '53 - Life Partner', value: '53' },
    { display: 'G8 - Other Relationship', value: 'G8' },
];
export const CoveragePriority = [
    { value: '', display: '' },
    { value: 'P', display: 'Primary' },
    { value: 'S', display: 'Secondary' },
    { value: 'T', display: 'Tertiary' },
    { value: 'O', display: 'Other' },
];
export const TransportReason = [
    { value: '1', display: '1- Medical Appointment' },
    { value: '2', display: '2- Hospital Discharge' },
    { value: '3', display: '3- Hospital Admission' },
    { value: '4', display: '4- Interfacility Transfer' },
    { value: '5', display: '5- Speciality Care' },
    { value: '6', display: '6- Non-Emergency Medical Transport' },
    { value: '7', display: '7- Chemotherapy/Radiation Treatment' },
    { value: '8', display: '8- Dialysis Treatment' },
]
export const PWK = [
    { value: "-1", display: "" },
    { value: "03", display: "03 - Report Justifying Treatment Beyond Utilization Guidelines" },
    { value: "04", display: "04 - Drugs Administered" },
    { value: "05", display: "05 - Treatment Diagnosis" },
    { value: "06", display: "06 - Initial Assessment" },
    { value: "07", display: "07 - Functional Goals" },
    { value: "08", display: "08 - Plan of Treatment" },
    { value: "09", display: "09 - Progress Report" },
    { value: "10", display: "10 - Continued Treatment" },
    { value: "11", display: "11 - Chemical Analysis" },
    { value: "13", display: "13 - Certified Test Report" },
    { value: "15", display: "15 - Justification for Admission" },
    { value: "21", display: "21 - Recovery Plan" },
    { value: "A3", display: "A3 - Allergies/Sensitivities Document" },
    { value: "A4", display: "A4 - Autopsy Report" },
    { value: "AM", display: "AM - Ambulance Certification" },
    { value: "AS", display: "AS - Admission Summary" },
    { value: "B2", display: "B2 - Prescription" },
    { value: "B3", display: "B3 - Physician Order" },
    { value: "B4", display: "B4 - Referral Form" },
    { value: "BR", display: "BR - Benchmark Testing Results" },
    { value: "BS", display: "BS - Baseline" },
    { value: "BT", display: "BT - Blanket Test Results" },
    { value: "CB", display: "CB - Chiropractic Justification" },
    { value: "CK", display: "CK - Consent Form(s)" },
    { value: "CT", display: "CT - Certification" },
    { value: "D2", display: "D2 - Drug Profile Document" },
    { value: "DA", display: "DA - Dental Models" },
    { value: "DB", display: "DB - Durable Medical Equipment Prescription" },
    { value: "DG", display: "DG - Diagnostic Report" },
    { value: "DJ", display: "DJ - Discharge Monitoring Report" },
    { value: "DS", display: "DS - Discharge Summary" },
    { value: "EB", display: "EB - Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payor)" },
    { value: "HC", display: "HC - Health Certificate" },
    { value: "HR", display: "HR - Health Clinic Records" },
    { value: "I5", display: "I5 - Immunization Record" },
    { value: "IR", display: "IR - State School Immunization Records" },
    { value: "LA", display: "LA - Laboratory Results" },
    { value: "M1", display: "M1 - Medical Record Attachment" },
    { value: "MT", display: "MT - Models" },
    { value: "NN", display: "NN - Nursing Notes" },
    { value: "OB", display: "OB - Operative Note" },
    { value: "OC", display: "OC - Oxygen Content Averaging Report" },
    { value: "OD", display: "OD - Orders and Treatments Document" },
    { value: "OE", display: "OE - Objective Physical Examination (including vital signs) Document" },
    { value: "OX", display: "OX - Oxygen Therapy Certification" },
    { value: "OZ", display: "OZ - Support Data for Claim" },
    { value: "P4", display: "P4 - Pathology Report" },
    { value: "P5", display: "P5 - Patient Medical History Document" },
    { value: "PE", display: "PE - Parenteral or Enteral Certification" },
    { value: "PN", display: "PN - Physical Therapy Notes" },
    { value: "PO", display: "PO - Prosthetics or Orthotic Certification" },
    { value: "PQ", display: "PQ - Paramedical Results" },
    { value: "PY", display: "PY - Physician’s Report" },
    { value: "PZ", display: "PZ - Physical Therapy Certification" },
    { value: "RB", display: "RB - Radiology Films" },
    { value: "RR", display: "RR - Radiology Reports" },
    { value: "RT", display: "RT - Report of Tests and Analysis Report" },
    { value: "RX", display: "RX - Renewable Oxygen Content Averaging Report" },
    { value: "SG", display: "SG - Symptoms Document" },
    { value: "V5", display: "V5 - Death Notification" },
    { value: "XP", display: "XP - Photographs" }
]
export const GridFooter = [
    { value: 'This Page', display: 'This Page' },
    { value: 'All', display: 'All' },
]
export const YesNO = [
    { value: '-1', display: '' },
    { value: '1', display: 'Yes' },
    { value: '0', display: 'No' },
]
export const ServiceTypeDropdown = [
    { value: 'false', display: 'Regular' },
    { value: 'true', display: 'PMPM' },
]
export const ChangeStatusClaim = [
    { value: 'Missing Info', display: 'Missing Info' },
    { value: 'In Review', display: 'In Review' },
    { value: 'Hold', display: 'Hold' },
    { value: 'New', display: 'New' },
    { value: 'ReSubmit', display: 'ReSubmit' },
]
export const ChangeStatusWithoutResubmit = [
    { value: 'Missing Info', display: 'Missing Info' },
    { value: 'In Review', display: 'In Review' },
    { value: 'Hold', display: 'Hold' },
    { value: 'New', display: 'New' },
    // { value: 'ReSubmit', display: 'ReSubmit' },
]
export const ResubmitAsDD = [
    { value: '1', display: '1 - Original Claim' },
    { value: '7', display: '7 - Replacement Claim' },
    { value: '8', display: '8 - Voided/Canceled Claim' },
]
export const SubmitType = [
    { value: 'Primary Insurance', display: 'Primary Insurance' },
    { value: 'Secondary Insurance', display: 'Secondary Insurance' },
]
export const POACode = [
    { value: '-1', display: '' },
    { value: 'Y', display: 'Yes' },
    { value: 'N', display: 'No' },
]
export const ClaimTypes = [
    { value: "-1", display: "" },
    { value: "P", display: "Professional" },
    { value: "I", display: "Institutional" },
    { value: "D", display: "Dental" },
]
export const Paid = [
    { value: '-1', display: '' },
    { value: '1', display: 'Yes' },
    { value: '0', display: 'No' },
    { value: '2', display: 'Partial ' },
]
export const ServiceTypeCode = [
    { value: '-1', display: '' },
    { value: '1', display: '1 - Medical Care' },
    { value: '2', display: '2 - Surgical' },
    { value: '3', display: '3 - Consultation' },
    { value: '4', display: '4 - Diagnostic X-Ray' },
    { value: '5', display: '5 - Diagnostic Lab' },
    { value: '6', display: '6 - Radiation Therapy' },
    { value: '7', display: '7 - Anesthesia' },
    { value: '8', display: '8 - Surgical Assistance' },
    { value: '9', display: '9 - Other Medical' },
    { value: '10', display: '10 - Blood Charges' },
    { value: '11', display: '11 - Used Durable Medical Equipment' },
    { value: '12', display: '12 - Durable Medical Equipment Purchase' },
    { value: '13', display: '13- Ambulatory Service Center Facility' },
    { value: '14', display: '14 - Renal Supplies in the Home' },
    { value: '15', display: '15 - Alternate Method Dialysis' },
    { value: '16', display: '16 - Chronic Renal Disease (CRD) Equipment' },
    { value: '17', display: '17 - Pre-Admission Testing' },
    { value: '18', display: '18 - Durable Medical Equipment Rental' },
    { value: '19', display: '19 - Pneumonia Vaccine' },
    { value: '20', display: '20 - Second Surgical Opinion' },
    { value: '21', display: '21 - Third Surgical Opinion' },
    { value: '22', display: '22 - Social Work' },
    { value: '23', display: '23 - Diagnostic Dental' },
    { value: '24', display: '24 - Periodontics' },
    { value: '25', display: '25 - Restorative' },
    { value: '26', display: '26 - Endodontics' },
    { value: '27', display: '27 - Maxillofacial Prosthetics' },
    { value: '28', display: '28 - Adjunctive Dental Services' },
    { value: '30', display: '30 - Health Benefit Plan Coverage' },
    { value: '32', display: '32 - Plan Waiting Period' },
    { value: '33', display: '33 - Chiropractic' },
    { value: '34', display: '34 - Chiropractic Office Visits' },
    { value: '35', display: '35 - Dental Care' },
    { value: '36', display: '36 - Dental Crowns' },
    { value: '37', display: '37 - Dental Accident' },
    { value: '38', display: '38 - Orthodontics' },
    { value: '39', display: '39 - Prosthodontics' },
    { value: '40', display: '40 - Oral Surgery' },
    { value: '41', display: '41 - Routine (Preventive) Dental' },
    { value: '42', display: '42 - Home Health Care' },
    { value: '43', display: '43 - Home Health Prescriptions' },
    { value: '44', display: '44 - Home Health Visits' },
    { value: '45', display: '45 - Hospice' },
    { value: '46', display: '46 - Respite Care' },
    { value: '47', display: '47 - Hospital' },
    { value: '48', display: '48 - Hospital - Inpatient' },
    { value: '49', display: '49 - Hospital - Room and Board' },
    { value: '50', display: '50 - Hospital - Outpatient' },
    { value: '51', display: '51 - Hospital - Emergency Accident' },
    { value: '52', display: '52 - Hospital - Emergency Medical' },
    { value: '53', display: '53 - Hospital - Ambulatory Surgical' },
    { value: '54', display: '54 - Long Term Care' },
    { value: '55', display: '55 - Major Medical' },
    { value: '56', display: '56 - Medically Related Transportation' },
    { value: '57', display: '57 - Air Transportation' },
    { value: '58', display: '58 - Cabulance' },
    { value: '59', display: '59 - Licensed Ambulance' },
    { value: '60', display: '60 - General Benefits' },
    { value: '61', display: '61 - In-vitro Fertilization' },
    { value: '62', display: '62 - MRI/CAT Scan' },
    { value: '63', display: '63 - Donor Procedures' },
    { value: '64', display: '64 - Acupuncture' },
    { value: '65', display: '65 - Newborn Care' },
    { value: '66', display: '66 - Pathology' },
    { value: '67', display: '67 - Smoking Cessation' },
    { value: '68', display: '68 - Well Baby Care' },
    { value: '69', display: '69 - Maternity' },
    { value: '70', display: '70 - Transplants' },
    { value: '71', display: '71 - Audiology Exam' },
    { value: '72', display: '72 - Inhalation Therapy' },
    { value: '73', display: '73 - Diagnostic Medical' },
    { value: '74', display: '74 - Private Duty Nursing' },
    { value: '75', display: '75 - Prosthetic Device' },
    { value: '76', display: '76 - Dialysis' },
    { value: '77', display: '77 - Otological Exam' },
    { value: '78', display: '78 - Chemotherapy' },
    { value: '79', display: '79 - Allergy Testing' },
    { value: '80', display: '80 - Immunizations' },
    { value: '81', display: '81 - Routine Physical' },
    { value: '82', display: '82 - Family Planning' },
    { value: '83', display: '83 - Infertility' },
    { value: '84', display: '84 - Abortion' },
    { value: '85', display: '85 - AIDS' },
    { value: '86', display: '86 - Emergency Services' },
    { value: '87', display: '87 - Cancer' },
    { value: '88', display: '88 - Pharmacy' },
    { value: '89', display: '89 - Free Standing Prescription Drug' },
    { value: '90', display: '90 - Mail Order Prescription Drug' },
    { value: '91', display: '91 - Brand Name Prescription Drug' },
    { value: '92', display: '92 - Generic Prescription Drug' },
    { value: '93', display: '93 - Podiatry' },
    { value: '94', display: '94 - Podiatry - Office Visits' },
    { value: '95', display: '95 - Podiatry - Nursing Home Visits' },
    { value: '96', display: '96 - Professional (Physician)' },
    { value: '97', display: '97 - Anesthesiologist' },
    { value: '98', display: '98 - Professional (Physician) Visit - Office' },
    { value: '99', display: '99 - Professional (Physician) Visit - Inpatient' },
    { value: 'A0', display: 'A0 - Professional (Physician) Visit - Outpatient' },
    { value: 'A1', display: 'A1 - Professional (Physician) Visit - Nursing Home' },
    { value: 'A2', display: 'A2 - Professional (Physician) Visit - Skilled Nursing Facility' },
    { value: 'A3', display: 'A3 - Professional (Physician) Visit - Home' },
    { value: 'A4', display: 'A4 - Psychiatric' },
    { value: 'A5', display: 'A5 - Psychiatric - Room and Board' },
    { value: 'A6', display: 'A6 - Psychotherapy' },
    { value: 'A7', display: 'A7 - Psychiatric - Inpatient' },
    { value: 'A8', display: 'A8 - Psychiatric - Outpatient' },
    { value: 'A9', display: 'A9 - Rehabilitation' },
    { value: 'AA', display: 'AA - Rehabilitation - Room and Board' },
    { value: 'AB', display: 'AB - Rehabilitation - Inpatient' },
    { value: 'AC', display: 'AC - Rehabilitation - Outpatient' },
    { value: 'AD', display: 'AD - Occupational Therapy' },
    { value: 'AE', display: 'AE - Physical Medicine' },
    { value: 'AF', display: 'AF - Speech Therapy' },
    { value: 'AG', display: 'AG - Skilled Nursing Care' },
    { value: 'AH', display: 'AH - Skilled Nursing Care - Room and Board' },
    { value: 'AI', display: 'AI - Substance Abuse' },
    { value: 'AJ', display: 'AJ - Alcoholism' },
    { value: 'AK', display: 'AK - Drug Addiction' },
    { value: 'AL', display: 'AL - Vision (Optometry)' },
    { value: 'AM', display: 'AM - Frames' },
    { value: 'AN', display: 'AN - Routine Exam' },
    { value: 'AO', display: 'AO - Lenses' },
    { value: 'AQ', display: 'AQ - Nonmedically Necessary Physical' },
    { value: 'AR', display: 'AR - Experimental Drug Therapy' },
    { value: 'B1', display: 'B1 - Burn Care' },
    { value: 'B2', display: 'B2 - Brand Name Prescription Drug - Formulary' },
    { value: 'B3', display: 'B3 - Brand Name Prescription Drug - Non-Formulary' },
    { value: 'BA', display: 'BA - Independent Medical Evaluation' },
    { value: 'BB', display: 'BB - Partial Hospitalization (Psychiatric)' },
    { value: 'BC', display: 'BC - Day Care (Psychiatric)' },
    { value: 'BD', display: 'BD - Cognitive Therapy' },
    { value: 'BE', display: 'BE - Massage Therapy' },
    { value: 'BF', display: 'BF - Pulmonary Rehabilitation' },
    { value: 'BG', display: 'BG - Cardiac Rehabilitation' },
    { value: 'BH', display: 'BH - Pediatric' },
    { value: 'BI', display: 'BI - Nursery' },
    { value: 'BJ', display: 'BJ - Skin' },
    { value: 'BK', display: 'BK - Orthopedic' },
    { value: 'BL', display: 'BL - Cardiac' },
    { value: 'BM', display: 'BM - Lymphatic' },
    { value: 'BN', display: 'BN - Gastrointestinal' },
    { value: 'BP', display: 'BP - Endocrine' },
    { value: 'BQ', display: 'BQ - Neurology' },
    { value: 'BR', display: 'BR - Eye' },
    { value: 'BS', display: 'BS - Invasive Procedures' },
    { value: 'BT', display: 'BT - Gynecological' },
    { value: 'BU', display: 'BU - Obstetrical' },
    { value: 'BV', display: 'BV - Obstetrical/Gynecological' },
    { value: 'BW', display: 'BW - Mail Order Prescription Drug - Formulary' },
    { value: 'BX', display: 'BX - Mail Order Prescription Drug - Non-Formulary' },
    { value: 'BY', display: 'BY - Physician Visit - Office - Formulary' },
    { value: 'BZ', display: 'BZ - Physician Visit - Office - Non-Formulary' },
    { value: 'C1', display: 'C1 - Coronary Care' },
    { value: 'C2', display: 'C2 - Intensive Care' },
    { value: 'CA', display: 'CA - Pulmonary' },
    { value: 'CB', display: 'CB - Oncology' },
    { value: 'CC', display: 'CC - Radiation Therapy' },
    { value: 'CD', display: 'CD - Chemotherapy' },
    { value: 'CE', display: 'CE - Allergy' },
    { value: 'CF', display: 'CF - Immunization' },
    { value: 'CG', display: 'CG - Renal' },
    { value: 'CH', display: 'CH - Neurosurgical' },
    { value: 'CI', display: 'CI - Surgeon - Non-Cardiac' },
    { value: 'CJ', display: 'CJ - Surgeon - Cardiac' },
    { value: 'CK', display: 'CK - Anesthesia' },
    { value: 'CL', display: 'CL - Assistant Surgeon' },
    { value: 'CM', display: 'CM - Podiatrist' },
    { value: 'CN', display: 'CN - Chiropractor' },
    { value: 'CO', display: 'CO - Dietician' },
    { value: 'CP', display: 'CP - Anesthetist' },
    { value: 'CQ', display: 'CQ - Case Management' },
    { value: 'DG', display: 'DG - Dermatology' },
    { value: 'DM', display: 'DM - Durable Medical Equipment' },
    { value: 'DS', display: 'DS - Diabetic Supplies' },
    { value: 'GF', display: 'GF - Generic Prescription Drug - Formulary' },
    { value: 'GN', display: 'GN - Generic Prescription Drug - Non-Formulary' },
    { value: 'GY', display: 'GY - Allergy' },
    { value: 'IC', display: 'IC - Intensive Care' },
    { value: 'MH', display: 'MH - Mental Health' },
    { value: 'NI', display: 'NI - Neonatal Intensive Care' },
    { value: 'ON', display: 'ON - Oncology' },
    { value: 'PT', display: 'PT - Physical Therapy' },
    { value: 'PU', display: 'PU - Pulmonary' },
    { value: 'RN', display: 'RN - Renal' },
    { value: 'RT', display: 'RT - Residential Psychiatric Treatment' },
    { value: 'TC', display: 'TC - Transitional Care' },
    { value: 'TN', display: 'TN - Transitional Nursery Care' },
    { value: 'UC', display: 'UC - Urgent Care' }
]
export const PatientStatus = [
    { value: '-1', display: '' },
    { value: '01', display: '01 - Discharged/Transferred to Home or Self-care' },
    { value: '02', display: '02 - Discharged/Transferred to Another Short-term General Hospital' },
    { value: '03', display: '03 - Discharged/Transferred to a Skilled Nursing Facility (SNF) with Medicare Certification' },
    { value: '04', display: '04 - Discharged/Transferred to an Intermediate Care Facility (ICF)' },
    { value: '05', display: '05 - Discharged/Transferred to a Designated Cancer Center or Children\'s Hospital' },
    { value: '06', display: '06 - Discharged/Transferred to a Medicare-Certified Long-Term Care Hospital' },
    { value: '07', display: '07 - Discharged/Transferred to Another Type of Institution for Specialized Care or Discharge Planning' },
    { value: '09', display: '09 - Discharged/Transferred to Home Under Care of Organized Home Health Service Organization' },
    { value: '21', display: '21 - Admitted as an Inpatient to this Hospital' },
    { value: '20', display: '20 - Expired' },
];
export const AdmissionSource = [
    { value: '-1', display: '' },
    { value: '1', display: '1 - Physician Referral' },
    { value: '2', display: '2 - Clinic Referral' },
    { value: '3', display: '3 - HMO Referral' },
    { value: '4', display: '4 - Transfer from a Hospital' },
    { value: '5', display: '5 - Transfer from a Skilled Nursing Facility' },
    { value: '6', display: '6 - Transfer from Another Healthcare Facility' },
    { value: '7', display: '7 - Emergency Room' },
    { value: '8', display: '8 - Court/Law Enforcement' },
    { value: '9', display: '9 - Information Not Available' },
    { value: '0', display: '0 - Not Applicable' },
];
export const AdmissionType = [
    { value: '-1', display: '' },
    { value: '1', display: '1 - Emergency' },
    { value: '2', display: '2 - Urgent' },
    { value: '3', display: '3 - Elective' },
    { value: '4', display: '4 - Newborn' },
    { value: '5', display: '5 - Trauma Center' },
    { value: '6', display: '6 - Transfer from Another Facility' },
    { value: '7', display: '7 - Readmission' },
    { value: '8', display: '8 - Psychiatric' },
    { value: '9', display: '9 - Observation' },
    { value: '10', display: '10 - Rehabilitation' },
];
export const BillingMethod = [
    { value: '', display: '' },
    { value: 'Paper', display: 'Paper' },
    { value: 'EDI', display: 'EDI' },
]
export const hourList = [
    { value: '01', display: '01' },
    { value: '02', display: '02' },
    { value: '03', display: '03' },
    { value: '04', display: '04' },
    { value: '05', display: '05' },
    { value: '06', display: '06' },
    { value: '07', display: '07' },
    { value: '08', display: '08' },
    { value: '09', display: '09' },
    { value: '10', display: '10' },
    { value: '11', display: '11' },
    { value: '12', display: '12' }
];
export const minuteList = [
    { value: '00', display: '00' },
    { value: '01', display: '01' },
    { value: '02', display: '02' },
    { value: '03', display: '03' },
    { value: '04', display: '04' },
    { value: '05', display: '05' },
    { value: '06', display: '06' },
    { value: '07', display: '07' },
    { value: '08', display: '08' },
    { value: '09', display: '09' },
    { value: '10', display: '10' },
    { value: '11', display: '11' },
    { value: '12', display: '12' },
    { value: '13', display: '13' },
    { value: '14', display: '14' },
    { value: '15', display: '15' },
    { value: '16', display: '16' },
    { value: '17', display: '17' },
    { value: '18', display: '18' },
    { value: '19', display: '19' },
    { value: '20', display: '20' },
    { value: '21', display: '21' },
    { value: '22', display: '22' },
    { value: '23', display: '23' },
    { value: '24', display: '24' },
    { value: '25', display: '25' },
    { value: '26', display: '26' },
    { value: '27', display: '27' },
    { value: '28', display: '28' },
    { value: '29', display: '29' },
    { value: '30', display: '30' },
    { value: '31', display: '31' },
    { value: '32', display: '32' },
    { value: '33', display: '33' },
    { value: '34', display: '34' },
    { value: '35', display: '35' },
    { value: '36', display: '36' },
    { value: '37', display: '37' },
    { value: '38', display: '38' },
    { value: '39', display: '39' },
    { value: '40', display: '40' },
    { value: '41', display: '41' },
    { value: '42', display: '42' },
    { value: '43', display: '43' },
    { value: '44', display: '44' },
    { value: '45', display: '45' },
    { value: '46', display: '46' },
    { value: '47', display: '47' },
    { value: '48', display: '48' },
    { value: '49', display: '49' },
    { value: '50', display: '50' },
    { value: '51', display: '51' },
    { value: '52', display: '52' },
    { value: '53', display: '53' },
    { value: '54', display: '54' },
    { value: '55', display: '55' },
    { value: '56', display: '56' },
    { value: '57', display: '57' },
    { value: '58', display: '58' },
    { value: '59', display: '59' }
];
export const periodList = [
    { value: 'AM', display: 'AM' },
    { value: 'PM', display: 'PM' }
];
export const MinutesByInterval = [
    { "display": "5 Min", "value": "5" },
    { "display": "10 Min", "value": "10" },
    { "display": "15 Min", "value": "15" },
    { "display": "20 Min", "value": "20" },
    { "display": "25 Min", "value": "25" },
    { "display": "30 Min", "value": "30" },
    { "display": "35 Min", "value": "35" },
    { "display": "40 Min", "value": "40" },
    { "display": "45 Min", "value": "45" },
    { "display": "50 Min", "value": "50" },
    { "display": "55 Min", "value": "55" },
    { "display": "60 Min", "value": "60" }
]
export const EDIType = [
    { value: "", display: "" },
    { value: '837 P', display: '837 P' },
    { value: '837 I', display: '837 I' },
    { value: '837 D', display: '837 D' },
]
export const EDITypeElecSub = [
    { value: -1, display: "" },
    { value: 'P', display: 'Professional' },
    { value: 'I', display: 'Institutional' },
]
export const DefaultBillingStatus = [
    { value: 'New', display: null },
    { value: 'New', display: 'New' },
    { value: 'InReview', display: 'InReview' },
    { value: 'Hold', display: 'Hold' },
]
export const BillingDocumentStatus = [
    { value: '', display: null },
    { color: 'New-bg', value: 'New', display: 'New' },
    { color: 'New-bg', value: 'Inprogress', display: 'In progress' },
    { color: 'Paid-bg', value: 'Completed', display: 'Completed' },
]
export const LanguageProficiencyDropdown = [
    { value: '-1', display: "" },
    { value: 'Fluent', display: 'Fluent' },
    { value: ' Intermediate', display: 'Intermediate' },
    { value: 'Basic ', display: 'Basic' },
]
export const SmokingStatusDropdown = [
    { value: '-1', display: "" },
    { value: 'Non-Smoker', display: 'Non-Smoker' },
    { value: ' Ex-Smoker', display: 'Ex-Smoker' },
    { value: 'Current non smoker but past smoking history unknown', display: 'Current non smoker but past smoking history unknown' },
    { value: 'Light cigarette smoker(1-9 cigs/day) ', display: 'Light cigarette smoker(1-9 cigs/day)' },
    { value: 'Moderate cigarette smoker(10-19 cigs/day)', display: 'Moderate cigarette smoker(10-19 cigs/day)' },
    { value: 'Heavy cigarette smoker(23-39 cigs/day) ', display: 'Heavy cigarette smoker(23-39 cigs/day)' },
    { value: 'Very Heavy cigarette smoker(40+ cigs/day) ', display: 'Very Heavy cigarette smoker(40+ cigs/day)' },
    { value: 'Cigar smoker ', display: 'Cigar smoker' },
    { value: 'Pipe smoker ', display: 'Pipe smoker' },
    { value: 'Heavy tobacco smoker ', display: 'Heavy tobacco smoker' },
    { value: 'Light tobacco smoker ', display: 'Light tobacco smoker' },
    { value: 'Current some day smoker ', display: 'Current some day smoker' },
]
export const PaperType = [
    { value: "", display: "" },
    { value: 'HCFA', display: 'HCFA' },
    { value: 'HCFA Plan', display: 'HCFA Plan' },
    { value: 'UB04', display: 'UB04' },
    { value: 'UB04 Plan', display: 'UB04 Plan' },
    { value: 'ADA', display: 'ADA' },
    { value: 'ADA Plan', display: 'ADA Plan' },
]
export const PrimaryContactType = [
    { value: '-1', display: '' },
    { value: 'Patient', display: 'Patient' },
    { value: 'Guarantor', display: 'Guarantor' },
    { value: 'Insurance Company', display: 'Insurance Company' },
    { value: 'Referring Provider', display: 'Referring Provider' },
    { value: 'Primary Care Physician (PCP)', display: 'Primary Care Physician (PCP)' },
    { value: 'Specialist', display: 'Specialist' },
    { value: 'Authorized Representative', display: 'Authorized Representative' },
    { value: 'Case Manager', display: 'Case Manager' },
    { value: 'Other ', display: 'Other ' },
]
export const PreferredCommunication = [
    { value: '-1', display: "" },
    { value: 'Cell Phone', display: 'Cell Phone' },
    { value: 'Home Phone', display: 'Home Phone' },
    { value: 'Work Phone', display: 'Work Phone' },
    { value: 'Email', display: 'Email' },
    { value: 'Text Message', display: 'Text Message' },
    { value: 'None', display: 'None' },
]
export const PreferredLanguage = [
    { value: '-1', display: "" },
    { value: 'English', display: 'English' },
    { value: 'Spanish', display: 'Spanish' },
    { value: 'French', display: 'French' },
    { value: 'German', display: 'German' },
    { value: 'Chinese (Simplified)', display: 'Chinese (Simplified)' },
    { value: 'Chinese (Traditional)', display: 'Chinese (Traditional)' },
    { value: 'Arabic', display: 'Arabic' },
    { value: 'Hindi', display: 'Hindi' },
    { value: 'Portuguese', display: 'Portuguese' },
    { value: 'Russian', display: 'Russian' },
    { value: 'Italian', display: 'Italian' },
    { value: 'Japanese', display: 'Japanese' },
    { value: 'Korean', display: 'Korean' },
    { value: 'Dutch ', display: 'Dutch' },
    { value: 'Turkish ', display: 'Turkish' },
    { value: 'Polish ', display: 'Polish' },
    { value: 'Swedish ', display: 'Swedish' },
    { value: 'Finnish ', display: 'Finnish' },
    { value: 'Greek ', display: 'Greek' },
    { value: 'Thai ', display: 'Thai' },
    { value: 'Vietnamese ', display: 'Vietnamese' },
    { value: 'Hebrew ', display: 'Hebrew' },
    { value: 'Urdu ', display: 'Urdu' },
    { value: 'Bengali ', display: 'Bengali' },
    { value: 'Indonesian ', display: 'Indonesian' },
    { value: 'Tamil ', display: 'Tamil' },
    { value: 'Tagalog ', display: 'Tagalog' },
    { value: 'Swahili ', display: 'Swahili' },
    { value: 'Malay ', display: 'Malay' },
    { value: 'Romanian ', display: 'Romanian' },
    { value: 'Czech ', display: 'Czech' },
    { value: 'Hungarian ', display: 'Hungarian' },
    { value: 'Ukrainian ', display: 'Ukrainian' },

]
export const ClaimStatus = [
    { color: 'MissingInfo-bg', value: 'Missing Info', display: 'Missing Info' },
    { color: 'InReview-bg', value: 'In Review', display: 'In Review' },
    { color: 'Hold-bg', value: 'Hold', display: 'Hold' },
    { color: 'New-bg', value: 'New', display: 'New' },
    { color: 'Submitted-bg', value: 'Submitted', display: 'Submitted' },
    { color: 'New-bg', value: 'ReSubmit', display: 'ReSubmit' },
    { color: 'Acknowledged-bg', value: 'Acknowledged by CH', display: 'Acknowledged by CH' },
    { color: 'RejectedCH-bg', value: 'Rejected by CH', display: 'Rejected by CH' },
    { color: 'Forwarded-bg', value: 'Forwarded to Payer', display: 'Forwarded to Payer' },
    { color: 'Received-bg', value: 'Received by Payer', display: 'Received by Payer' },
    { color: 'Accepted-bg', value: 'Accepted by Payer', display: 'Accepted by Payer' },
    { color: 'RejectedPayer-bg', value: 'Rejected by Payer', display: 'Rejected by Payer' },
    { color: 'Paid-bg', value: 'Paid', display: 'Paid' },
    { color: 'Denied-bg', value: 'Denied', display: 'Denied' },
    { color: 'WriteOff-bg', value: 'WriteOff', display: 'WriteOff' },
    { color: 'SecondaryClaim-bg', value: 'Secondary Claim', display: 'Secondary Claim' },
    { color: 'Crossover-bg', value: 'Crossover', display: 'Crossover' },
    { color: 'PartialDenied-bg', value: 'Partial Denied', display: 'Partial Denied' },
    { color: 'DuePatient-bg', value: 'Due Patient', display: 'Due Patient' },
]
export const DateFormat = 'yyyy/MM/dd';
export const DateFormat_dMy = 'dd/MM/yyyy';
export function DateFormat_YMd(date) {
    if (date) {
        const dateParts = date.split("/");
        //===========Shown value to new Date(yyyy-mm-d) for Calendar============//
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        return new Date(formattedDate);
    }
}
export function MdY_To_NewDate(date) {
    if (date) {
        const dateParts = date.split("/");
        //===========Shown value to new Date(yyyy-mm-d) for Calendar============//
        const formattedDate = `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`;
        return new Date(formattedDate);
    }
}
export function convertDateToYYYYMMDD(dateString) {
    const [month, day, year] = dateString.split("/");
    return `${year}/${month}/${day}`;
}
export const isValidMMDDYYYY = (dateString) => {
    // Check format using RegEx
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
    if (!regex.test(dateString)) return false;

    const [month, day, year] = dateString.split('/').map(Number);
    const date = new Date(`${year}-${month}-${day}`);

    return (
        date.getFullYear() === year &&
        date.getMonth() + 1 === month && // getMonth is 0-indexed
        date.getDate() === day
    );
};
export const DateComparison = (dateOne, dateTwo) => {

    const format = 'MM/dd/yyyy';

    const date1 = parse(dateOne, format, new Date());
    const date2 = parse(dateTwo, format, new Date());

    return isBefore(date1, date2) || isEqual(date1, date2);
}
///////////convertTimeToHMS/////////////////
export const convertTimeToHMS = (timeInMillis, type) => {
    let date = new Date(new Date().getTime() - timeInMillis?.getTime()); //just now being Jan 01 1970
    const currentDate = new Date(date.getUTCFullYear(), 0, 1); //Jan 01 1970
    let days = date.getUTCDate().toString().padStart(2, '0');
    days = date.getUTCDate() - 1;
    days = days.toString().padStart(2, '0');
    days = days !== '00' ? `${days}d` : ''
    let hours = date.getUTCHours().toString().padStart(2, '0');
    hours = hours !== '00' ? `${hours}h` : ''
    let minutes = date.getUTCMinutes().toString().padStart(2, '0');
    minutes = minutes !== '00' ? `${minutes}m` : ''
    let seconds = date.getUTCSeconds().toString().padStart(2, '0');
    seconds = seconds !== '00' ? `${seconds}s ago` : 'just now'


    return (type === 'single' ?
        `${days} ${!days ? hours : ''} ${!hours ? minutes : ''} ${!minutes ? seconds : ''}` :
        `${hours} ${minutes} ${seconds}`);
}
///////////////////////// Custom UseRef //////////////////////
export const formatedDate = () => {
    let currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${month}/${day}/${year}`;
}

export const getDayName = (date = new Date()) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[date.getDay()];
};

export const statusColors = () => {
    return {
        Claim: {
            new: 'new',
            writeOff: 'write_off',
            hold: 'hold',
            Submitted: 'Submitted',
            paid: 'paid',
            denied: 'denied',
        },
        Submission: {

        },
        Payment: {

        }
    }
}

export const TotalTime = [
    { value: '', display: '' },
    { value: '12:00 AM', display: '12:00 AM' },
    { value: '12:30 AM', display: '12:30 AM' },
    { value: '01:00 AM', display: '01:00 AM' },
    { value: '01:30 AM', display: '01:30 AM' },
    { value: '02:00 AM', display: '02:00 AM' },
    { value: '02:30 AM', display: '02:30 AM' },
    { value: '03:00 AM', display: '03:00 AM' },
    { value: '03:30 AM', display: '03:30 AM' },
    { value: '04:00 AM', display: '04:00 AM' },
    { value: '04:30 AM', display: '04:30 AM' },
    { value: '05:00 AM', display: '05:00 AM' },
    { value: '05:30 AM', display: '05:30 AM' },
    { value: '06:00 AM', display: '06:00 AM' },
    { value: '06:30 AM', display: '06:30 AM' },
    { value: '07:00 AM', display: '07:00 AM' },
    { value: '07:30 AM', display: '07:30 AM' },
    { value: '08:00 AM', display: '08:00 AM' },
    { value: '08:30 AM', display: '08:30 AM' },
    { value: '09:00 AM', display: '09:00 AM' },
    { value: '09:30 AM', display: '09:30 AM' },
    { value: '10:00 AM', display: '10:00 AM' },
    { value: '10:30 AM', display: '10:30 AM' },
    { value: '11:00 AM', display: '11:00 AM' },
    { value: '11:30 AM', display: '11:30 AM' },
    { value: '12:00 PM', display: '12:00 PM' },
    { value: '12:30 PM', display: '12:30 PM' },
    { value: '01:00 PM', display: '01:00 PM' },
    { value: '01:30 PM', display: '01:30 PM' },
    { value: '02:00 PM', display: '02:00 PM' },
    { value: '02:30 PM', display: '02:30 PM' },
    { value: '03:00 PM', display: '03:00 PM' },
    { value: '03:30 PM', display: '03:30 PM' },
    { value: '04:00 PM', display: '04:00 PM' },
    { value: '04:30 PM', display: '04:30 PM' },
    { value: '05:00 PM', display: '05:00 PM' },
    { value: '05:30 PM', display: '05:30 PM' },
    { value: '06:00 PM', display: '06:00 PM' },
    { value: '06:30 PM', display: '06:30 PM' },
    { value: '07:00 PM', display: '07:00 PM' },
    { value: '07:30 PM', display: '07:30 PM' },
    { value: '08:00 PM', display: '08:00 PM' },
    { value: '08:30 PM', display: '08:30 PM' },
    { value: '09:00 PM', display: '09:00 PM' },
    { value: '09:30 PM', display: '09:30 PM' },
    { value: '10:00 PM', display: '10:00 PM' },
    { value: '10:30 PM', display: '10:30 PM' },
    { value: '11:00 PM', display: '11:00 PM' },
    { value: '11:30 PM', display: '11:30 PM' },

]
export const TotalTimeArray = [
    { value: '', display: '' },
    { value: '12:00 AM', display: '12:00 AM' },
    { value: '12:15 AM', display: '12:15 AM' },
    { value: '12:30 AM', display: '12:30 AM' },
    { value: '12:45 AM', display: '12:45 AM' },
    { value: '01:00 AM', display: '01:00 AM' },
    { value: '01:15 AM', display: '01:15 AM' },
    { value: '01:30 AM', display: '01:30 AM' },
    { value: '01:45 AM', display: '01:45 AM' },
    { value: '02:00 AM', display: '02:00 AM' },
    { value: '02:15 AM', display: '02:15 AM' },
    { value: '02:30 AM', display: '02:30 AM' },
    { value: '02:45 AM', display: '02:45 AM' },
    { value: '03:00 AM', display: '03:00 AM' },
    { value: '03:15 AM', display: '03:15 AM' },
    { value: '03:30 AM', display: '03:30 AM' },
    { value: '03:45 AM', display: '03:45 AM' },
    { value: '04:00 AM', display: '04:00 AM' },
    { value: '04:15 AM', display: '04:15 AM' },
    { value: '04:30 AM', display: '04:30 AM' },
    { value: '04:45 AM', display: '04:45 AM' },
    { value: '05:00 AM', display: '05:00 AM' },
    { value: '05:15 AM', display: '05:15 AM' },
    { value: '05:30 AM', display: '05:30 AM' },
    { value: '05:45 AM', display: '05:45 AM' },
    { value: '06:00 AM', display: '06:00 AM' },
    { value: '06:15 AM', display: '06:15 AM' },
    { value: '06:30 AM', display: '06:30 AM' },
    { value: '06:45 AM', display: '06:45 AM' },
    { value: '07:00 AM', display: '07:00 AM' },
    { value: '07:15 AM', display: '07:15 AM' },
    { value: '07:30 AM', display: '07:30 AM' },
    { value: '07:45 AM', display: '07:45 AM' },
    { value: '08:00 AM', display: '08:00 AM' },
    { value: '08:15 AM', display: '08:15 AM' },
    { value: '08:30 AM', display: '08:30 AM' },
    { value: '08:45 AM', display: '08:45 AM' },
    { value: '09:00 AM', display: '09:00 AM' },
    { value: '09:15 AM', display: '09:15 AM' },
    { value: '09:30 AM', display: '09:30 AM' },
    { value: '09:45 AM', display: '09:45 AM' },
    { value: '10:00 AM', display: '10:00 AM' },
    { value: '10:15 AM', display: '10:15 AM' },
    { value: '10:30 AM', display: '10:30 AM' },
    { value: '10:45 AM', display: '10:45 AM' },
    { value: '11:00 AM', display: '11:00 AM' },
    { value: '11:15 AM', display: '11:15 AM' },
    { value: '11:30 AM', display: '11:30 AM' },
    { value: '11:45 AM', display: '11:45 AM' },
    { value: '12:00 PM', display: '12:00 PM' },
    { value: '12:15 PM', display: '12:15 PM' },
    { value: '12:30 PM', display: '12:30 PM' },
    { value: '12:45 PM', display: '12:45 PM' },
    { value: '01:00 PM', display: '01:00 PM' },
    { value: '01:15 PM', display: '01:15 PM' },
    { value: '01:30 PM', display: '01:30 PM' },
    { value: '01:45 PM', display: '01:45 PM' },
    { value: '02:00 PM', display: '02:00 PM' },
    { value: '02:15 PM', display: '02:15 PM' },
    { value: '02:30 PM', display: '02:30 PM' },
    { value: '02:45 PM', display: '02:45 PM' },
    { value: '03:00 PM', display: '03:00 PM' },
    { value: '03:15 PM', display: '03:15 PM' },
    { value: '03:30 PM', display: '03:30 PM' },
    { value: '03:45 PM', display: '03:45 PM' },
    { value: '04:00 PM', display: '04:00 PM' },
    { value: '04:15 PM', display: '04:15 PM' },
    { value: '04:30 PM', display: '04:30 PM' },
    { value: '04:45 PM', display: '04:45 PM' },
    { value: '05:00 PM', display: '05:00 PM' },
    { value: '05:15 PM', display: '05:15 PM' },
    { value: '05:30 PM', display: '05:30 PM' },
    { value: '05:45 PM', display: '05:45 PM' },
    { value: '06:00 PM', display: '06:00 PM' },
    { value: '06:15 PM', display: '06:15 PM' },
    { value: '06:30 PM', display: '06:30 PM' },
    { value: '06:45 PM', display: '06:45 PM' },
    { value: '07:00 PM', display: '07:00 PM' },
    { value: '07:15 PM', display: '07:15 PM' },
    { value: '07:30 PM', display: '07:30 PM' },
    { value: '07:45 PM', display: '07:45 PM' },
    { value: '08:00 PM', display: '08:00 PM' },
    { value: '08:15 PM', display: '08:15 PM' },
    { value: '08:30 PM', display: '08:30 PM' },
    { value: '08:45 PM', display: '08:45 PM' },
    { value: '09:00 PM', display: '09:00 PM' },
    { value: '09:15 PM', display: '09:15 PM' },
    { value: '09:30 PM', display: '09:30 PM' },
    { value: '09:45 PM', display: '09:45 PM' },
    { value: '10:00 PM', display: '10:00 PM' },
    { value: '10:15 PM', display: '10:15 PM' },
    { value: '10:30 PM', display: '10:30 PM' },
    { value: '10:45 PM', display: '10:45 PM' },
    { value: '11:00 PM', display: '11:00 PM' },
    { value: '11:15 PM', display: '11:15 PM' },
    { value: '11:30 PM', display: '11:30 PM' },
    { value: '11:45 PM', display: '11:45 PM' },

]
//////////// timeFormateChecker /////////////////////////
export function checkTimeFormat(timeString) {
    // Regular expression for 12-hour format with am/pm
    const regex12Hour = /^(1[0-2]|0?[1-9]):[0-5][0-9]\s?(AM|PM)$/i;

    // Regular expression for 24-hour format
    const regex24Hour = /^([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;

    if (regex12Hour.test(timeString)) {
        return '12-hour format';
    } else if (regex24Hour.test(timeString)) {
        return '24-hour format';
    } else {
        return 'Invalid time format';
    }
}

export function convertTo24Hour(time12h) {
    let [time, modifier] = time12h.split(" ");

    let [hours, minutes] = time.split(":");

    if (modifier === "PM" && hours !== "12") {
        hours = String(Number(hours) + 12);
    } else if (modifier === "AM" && hours === "12") {
        hours = "00";
    }

    return `${hours}:${minutes}`;
}

export function convertTo12Hour(timeInput) {
    if (!timeInput || typeof timeInput !== "string") return "";

    // If time already contains AM or PM, assume it's already in 12-hour format
    if (timeInput.toUpperCase().includes("AM") || timeInput.toUpperCase().includes("PM")) {
        return timeInput;
    }

    let [hours, minutes] = timeInput.split(":").map(Number);

    if (isNaN(hours) || isNaN(minutes)) return "";

    const modifier = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${hours}:${String(minutes).padStart(2, '0')} ${modifier}`;
}
//////////// Next Action Data /////////////////////////
export const NextActionData = [
    { display: "", value: "" },
    { display: "No Action at This Time", value: "No Action at This Time" },
    { display: "Apply Write Off If Allowed > 0", value: "ApplyWriteoff" },
    { display: "Apply Contractual Adjustment", value: "Apply Contractual Adjustment" },
    { display: "Transfer to Patient", value: "Transfer to Patient" },
    { display: "Change Status", value: "Change Status" },
];
///////////////////////////////////////////////
export default States;

// To check if opened tab is a child Tab
export const isChildWindow = window.name.startsWith('Child_Tab ');


export const ReactionData = [
    { value: 'Unknown', display: 'Unknown' },
    { value: 'Anaphylactic Shock', display: 'Anaphylactic Shock' },
    { value: 'Itching', display: 'Itching' },
    { value: 'Hives (Urticaria)', display: 'Hives (Urticaria)' },
    { value: 'Swelling (Angioedema)', display: 'Swelling (Angioedema)' },
    { value: 'Rash', display: 'Rash' },
    { value: 'Difficulty Breathing', display: 'Difficulty Breathing' },
    { value: 'Shortness of Breath', display: 'Shortness of Breath' },
    { value: 'Coughing', display: 'Coughing' },
    { value: 'Chest Tightness', display: 'Chest Tightness' },
    { value: 'Nausea', display: 'Nausea' },
    { value: 'Vomiting', display: 'Vomiting' },
    { value: 'Diarrhea', display: 'Diarrhea' },
    { value: 'Fainting', display: 'Fainting' },
    { value: 'Dizziness', display: 'Dizziness' },
    { value: 'Headache', display: 'Headache' },
    { value: 'Tingling or Numbness', display: 'Tingling or Numbness' },
    { value: 'Drowsiness or Fatigue', display: 'Drowsiness or Fatigue' },
    { value: 'Abdominal Pain', display: 'Abdominal Pain' },
    { value: 'Loss of Appetite', display: 'Loss of Appetite' },
    { value: 'Palpitations (Fast Heartbeat)', display: 'Palpitations (Fast Heartbeat)' },
    { value: 'Fever', display: 'Fever' },
    { value: 'Muscle Pain or Weakness', display: 'Muscle Pain or Weakness' },
    { value: 'Joint Pain', display: 'Joint Pain' },
    { value: 'Hives', display: 'Hives' },
    { value: 'Swelling', display: 'Swelling' },
    { value: 'Difficulty breathing', display: 'Difficulty breathing' },
    { value: 'Wheezing', display: 'Wheezing' },
    { value: 'Anaphylaxis', display: 'Anaphylaxis' },
    { value: 'Shortness of breath', display: 'Shortness of breath' },
    { value: 'Chest tightness', display: 'Chest tightness' },
    { value: 'Runny nose', display: 'Runny nose' },
    { value: 'Watery eyes', display: 'Watery eyes' },
    { value: 'Sneezing', display: 'Sneezing' },
]
export const DrugAllergies = [
    { value: 'Penicillin', display: 'Penicillin' },
    { value: 'Amoxicillin', display: 'Amoxicillin' },
    { value: 'Aspirin', display: 'Aspirin' },
    { value: 'Ibuprofen', display: 'Ibuprofen' },
    { value: 'Morphine', display: 'Morphine' },
    { value: 'Codeine', display: 'Codeine' },
    { value: 'Sulfa drugs', display: 'Sulfa drugs' },
    { value: 'Tetracycline', display: 'Tetracycline' },
    { value: 'Erythromycin', display: 'Erythromycin' },
    { value: 'Ciprofloxacin', display: 'Ciprofloxacin' },
    { value: 'Vancomycin', display: 'Vancomycin' },
    { value: 'Insulin', display: 'Insulin' },
    { value: 'Latex', display: 'Latex' },
    { value: 'Contrast dye', display: 'Contrast dye' },
    { value: 'Anesthesia', display: 'Anesthesia' }
];

export const FoodAllergies = [
    { value: 'Peanuts', display: 'Peanuts' },
    { value: 'Tree nuts', display: 'Tree nuts' },
    { value: 'Milk', display: 'Milk' },
    { value: 'Eggs', display: 'Eggs' },
    { value: 'Fish', display: 'Fish' },
    { value: 'Shellfish', display: 'Shellfish' },
    { value: 'Soy', display: 'Soy' },
    { value: 'Wheat', display: 'Wheat' },
    { value: 'Sesame', display: 'Sesame' },
    { value: 'Strawberries', display: 'Strawberries' },
    { value: 'Chocolate', display: 'Chocolate' },
    { value: 'Tomatoes', display: 'Tomatoes' },
    { value: 'Citrus fruits', display: 'Citrus fruits' },
    { value: 'Food additives', display: 'Food additives' },
    { value: 'MSG', display: 'MSG' }
];

export const EnvironmentalAllergies = [
    { value: 'Pollen', display: 'Pollen' },
    { value: 'Dust mites', display: 'Dust mites' },
    { value: 'Pet dander', display: 'Pet dander' },
    { value: 'Mold', display: 'Mold' },
    { value: 'Grass', display: 'Grass' },
    { value: 'Trees', display: 'Trees' },
    { value: 'Ragweed', display: 'Ragweed' },
    { value: 'Bee stings', display: 'Bee stings' },
    { value: 'Wasp stings', display: 'Wasp stings' },
    { value: 'Ant bites', display: 'Ant bites' },
    { value: 'Nickel', display: 'Nickel' },
    { value: 'Perfume', display: 'Perfume' },
    { value: 'Cleaning Products', display: 'Cleaning Products' },
    { value: 'Smoke', display: 'Smoke' },
    { value: 'Chemical Fumes', display: 'Chemical Fumes' }
];
export const LOCFrameworkDropdown = [
    { value: "-1", display: "" },
    { value: "ASAM", display: "ASAM" },
    { value: "LOCUS", display: "LOCUS" },
];

export const ASAMLevelOfCareDropdown = [
    { value: "-1", display: "" },
    { value: "0.5", display: "0.5 - Early intervention" },
    { value: "1.0", display: "1.0 - Outpatient services" },
    { value: "1.5", display: "1.5 - Intensive outpatient / outpatient with support" },
    { value: "2.1", display: "2.1 - Intensive outpatient (high intensity)" },
    { value: "2.5", display: "2.5 - Partial hospitalization" },
    { value: "3.1", display: "3.1 - Clinically managed low-intensity residential" },
    { value: "3.3", display: "3.3 - High-intensity residential (cognitive impairment)" },
    { value: "3.5", display: "3.5 - Clinically managed high-intensity residential" },
    { value: "3.7", display: "3.7 - Medically monitored intensive inpatient/residential" },
    { value: "3.7_COE", display: "3.7 COE / BIO - Enhanced co-occurring or biomedical" },
    { value: "4.0", display: "4.0 - Medically managed inpatient (hospital level)" },
];

export const LOCUSLevelOfCareDropdown = [
    { value: "-1", display: "" },
    { value: "0", display: "Level 0 - Prevention / early intervention" },
    { value: "1", display: "Level 1 - Recovery maintenance" },
    { value: "2", display: "Level 2 - Low intensity outpatient" },
    { value: "3", display: "Level 3 - High intensity community-based care" },
    { value: "4", display: "Level 4 - Medically monitored non-residential care" },
    { value: "5", display: "Level 5 - Medically monitored residential care" },
    { value: "6", display: "Level 6 - Medically managed inpatient / hospital care" },
];

export const FeildsMappingTypeDropdown = [
    { value: "0", display: "AI" },
    { value: "1", display: "Non-AI" },
];